module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.storeInfo.brand_name || _vm.storeInfo.name_short) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.storeInfo.brand_name ? _vm.storeInfo.brand_name : _vm.storeInfo.name_short ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.name_short) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.name_short) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.storeInfo.name_short)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('store-form', {
    attrs: {
      "info": _vm.info
    },
    on: {
      "update:store-info": _vm.updateStoreInfo
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a6a51fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/UpStore.vue
// module id = 2439
// module chunks = 1